/* unplugin-vue-components disabled */import { render } from "./BaseSvg.vue?vue&type=template&id=dcf03dc2"
import script from "./BaseSvg.vue?vue&type=script&lang=js"
export * from "./BaseSvg.vue?vue&type=script&lang=js"

import "./BaseSvg.vue?vue&type=style&index=0&id=dcf03dc2&lang=stylus"

import exportComponent from "E:\\work\\AirLink-html\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__